import { useRestQuery } from 'utils/hooks/api/useRestQuery';
import { ListType } from 'modules/domains/list';

const LIST_TYPE_COUNT_ENDPOINT = '/i/lists/counts';

type ListTypeCountResponse = { [key in ListType | 'All']?: number };

export const useListTypeCountQuery = () =>
  useRestQuery<ListTypeCountResponse>(LIST_TYPE_COUNT_ENDPOINT);
